<template>
  <div class="payment-result-page payment-failed-page">
    <div class="result-container">
      <div class="failed-icon">
        <div class="failed-circle">
          <i class="el-icon-warning"></i>
        </div>
      </div>
      
      <h1 class="result-title">支付失败</h1>
      <p class="result-subtitle">{{ failMessage }}</p>
      
      <div class="order-info-card" v-if="orderInfo.order_no">
        <div class="info-row">
          <span class="label">订单编号</span>
          <span class="value">{{ orderInfo.order_no }}</span>
        </div>
        <div class="info-row">
          <span class="label">支付金额</span>
          <span class="value amount">¥{{ orderInfo.amount }}</span>
        </div>
      </div>
      
      <div class="help-card">
        <h3>常见问题</h3>
        <ul>
          <li>请检查您的账户余额是否充足</li>
          <li>请确认网络连接正常</li>
          <li>如多次支付失败，请更换支付方式</li>
          <li>如需帮助，请联系客服邮箱：lirui9894@qq.com</li>
        </ul>
      </div>
      
      <div class="action-buttons">
        <button class="btn-secondary" @click="goBack">返回首页</button>
        <button class="btn-primary" @click="retryPayment">重新支付</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentFailed',
  data() {
    return {
      orderInfo: {
        order_no: '',
        amount: 0
      },
      failMessage: '支付过程中出现异常，请稍后重试'
    }
  },
  mounted() {
    this.orderInfo.order_no = this.$route.query.order_no || ''
    this.orderInfo.amount = this.$route.query.amount || 0
    if (this.$route.query.reason) {
      this.failMessage = this.$route.query.reason
    }
  },
  methods: {
    goBack() {
      this.$router.push('/')
    },
    retryPayment() {
      if (this.orderInfo.order_no) {
        this.$router.push({
          path: '/subscribe',
          query: { retry_order: this.orderInfo.order_no }
        })
      } else {
        this.$router.push('/price')
      }
    }
  }
}
</script>

<style scoped>
.payment-result-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #0a0f1a;
}

.result-container {
  max-width: 520px;
  width: 100%;
  text-align: center;
}

.failed-icon {
  margin-bottom: 24px;
}

.failed-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255, 100, 100, 0.2) 0%, rgba(255, 100, 100, 0.1) 100%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #ff6464;
  border: 2px solid rgba(255, 100, 100, 0.3);
  animation: scaleIn 0.5s ease;
}

@keyframes scaleIn {
  from { transform: scale(0); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.result-title {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
}

.result-subtitle {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 32px;
}

.order-info-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  text-align: left;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.info-row:last-child {
  border-bottom: none;
}

.info-row .label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

.info-row .value {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}

.info-row .value.amount {
  color: #ff6464;
  font-size: 18px;
  font-weight: 700;
}

.help-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  text-align: left;
}

.help-card h3 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 16px;
}

.help-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.help-card li {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  padding-left: 16px;
  position: relative;
  line-height: 1.6;
}

.help-card li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: rgba(255, 255, 255, 0.3);
}

.action-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.btn-primary, .btn-secondary {
  padding: 14px 32px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.btn-primary {
  background: linear-gradient(135deg, #00e6ac, #00cc99);
  color: #0a0f1a;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 230, 172, 0.3);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
}
</style>
